export class UnitKRA{

    hrKRAId: string;
    unitId: string;
    weight = 1;
    divisionDescription: string;
    unitDescription: string;
    kraTitle: string;
    kraDescription: string;


}